import { getCountryCallingCode } from "react-phone-number-input";

// Display a known phone value while the API directory is loading. Country IDs
// and selectable options always come from the API, never from a bundled JSON.
export const getCountryMeta = (countryCode, optionLabel = "", byCode = {}) => {
  if (byCode[countryCode]) return byCode[countryCode];
  let dialCode = "";
  if (countryCode) {
    try {
      dialCode = getCountryCallingCode(countryCode);
    } catch {
      // An unknown country has no dial-code fallback.
    }
  }
  return {
    code: countryCode || "",
    name: optionLabel || countryCode || "International",
    dialCode,
    flagSrc: null,
  };
};
